import React from "react"
import { Button } from "reactstrap"
import * as FileSaver from 'file-saver'
import XLSX from 'sheetjs-style'

const ExportExcel =({ excelData, fileName}) =>{
    const fileType ='application/vnd.openxmlformats-officedocument.spreadsheetml.sheet; charset=utf-8' 
    const fileExtension = '.xlsx';
    const exportToExcel = async () =>{
        const ws = XLSX.utils.json_to_sheet(excelData);
        const wb = { Sheets: { 'data': ws}, SheetNames: ['data']};
        const excelBuffer = XLSX.write(wb, {bookType: 'xlsx', type:'array'});
        const data = new Blob([excelBuffer], {type: fileType});
        FileSaver.saveAs(data, fileName + fileExtension);
    }

    return(
        <>
            <Button 
                onClick={(e)=> exportToExcel(fileName)} color="primary"
                style={{ cursor:"pointer", fontSize: 14}}
            >
                Export To Excel
            </Button>
        </>
    )
}


export default ExportExcel